import { Tabs } from 'antd';
import { Form, Card, GetValidateFields, Confirm, ButtonAction, Button } from 'asumsi-components';
import React, { useEffect, useState } from 'react';
import PageEditorPostFormComponent from './editor';
import PageMetaDataPostFormComponent from './meta-data';
import PageSettingPostFormComponent from './settings';
import useAction from "@pages/post/hooks/useAction";
import topicAction from "@pages/topics/hooks/useAction";
import authorsAction from "@pages/users/hooks/useAction";
import { Link } from 'react-router-dom';
import { IPostAuthor } from '@interfaces/iresponse-post';
import moment from "moment";

export default function (props: any) {
    const { TabPane } = Tabs;
    const { match } = props;
    const idData = match.params.id;
    const { tags, getTags, isLoader, getDetail, postData, updateData, detail } = useAction();
    const { getData: getTopics, data: topics } = topicAction();
    const { getData: getAuthors, data: authors } = authorsAction();
    const [content, setContent] = useState();
    const [authorsInput, setAuthorsInput] = useState();
    const [tagsInput, setTagsInput] = useState();
    // initiate form data
    const initialFieldsValues: any = {
        title: null,
        content: null,
        slug: null,
        excerpt: null,
        authors: undefined,
        tags: undefined,
        publishDateTime: undefined,
        topicId: null,
        imageUrl: null,
        imageCreditBy: null,
        metaTitle: null,
        metaDescription: null,
        canonicalUrl: null,
        fbImageUrl: null,
        fbTitle: null,
        fbDescription: null,
        twitImageUrl: null,
        twitTitle: null,
        twitDescription: null
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [paramSubmit, setParamSubmit] = useState({});
    const [showConfirmation, setShowConfirm] = useState(false);

    useEffect(() => {
        getTags({ all: true });
        getTopics({ all: true });
        fetchAuthors();
        if (idData && !detail) {
            getDetail(idData);
        }
        if (idData && detail) {
            setDefault();
        }
    }, [detail]);


    // fetch settings authors
    const fetchAuthors = (param?: any) => {
        getAuthors({ all: true, role: "Admin", ...param });
    }
    // fetch data
    const setDefault = () => {
        if (detail) {
            setFieldsValues({
                title: detail.title,
                content: detail.content,
                slug: detail.slug,
                excerpt: detail.excerpt,
                authors: detail.authors && detail.authors.length > 0 ? detail.authors.map((ath: IPostAuthor) => {
                    const newData: any = {
                        userId: ath.userId,
                        firstName: ath.firstName,
                        lastName: ath.lastName,
                        userEmail: ath.userEmail
                    };
                    return JSON.stringify(newData)
                }) : undefined,
                tags: detail.tags ?? undefined,
                publishDateTime: detail.publishDateTime ?? undefined,
                topicId: detail.topic.id,
                imageUrl: detail.imageUrl,
                imageCreditBy: detail.imageCreditBy,
                metaTitle: detail.metaData ? detail.metaData.title : null,
                metaDescription: detail.metaData ? detail.metaData.description : null,
                canonicalUrl: detail.metaData ? detail.metaData.canonicalUrl : null,
                fbImageUrl: detail.facebookCard ? detail.facebookCard.imageUrl : detail.imageUrl,
                fbTitle: detail.facebookCard ? detail.facebookCard.title : detail.metaData ? detail.metaData.title : null,
                fbDescription: detail.facebookCard ? detail.facebookCard.description : detail.metaData ? detail.metaData.description : null,
                twitImageUrl: detail.twitterCard ? detail.twitterCard.imageUrl : detail.imageUrl,
                twitTitle: detail.twitterCard ? detail.twitterCard.title : detail.metaData ? detail.metaData.title : null,
                twitDescription: detail.twitterCard ? detail.twitterCard.description : detail.metaData ? detail.metaData.description : null,
                status: detail.status == 'published'
            });
        }
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const finalFieldValues: any = {
            ...fieldsValues,
            content,
            tags: tagsInput ?? fieldsValues.tags,
            authors: authorsInput ?? fieldsValues.authors,
            publishDateTime: fieldsValues.publishDateTime ? moment(fieldsValues.publishDateTime).format() : null
        };

        const validateFields = GetValidateFields(finalFieldValues);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            let newValue: any = values;
            newValue = { ...newValue, authors: newValue.authors ? newValue.authors.map((dt: string) => JSON.parse(dt)) : [] };
            setParamSubmit(newValue);
            setShowConfirm(true);
        }
    };

    const onChageForm = (value: any) => {
        setFieldsValues({ ...fieldsValues, ...value });
    }

    // return JSX Element 
    return (
        <Card className="asumsi-card-form-shadow-rd-15">
            <Form titleBold={true}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Editor" key="1">
                        <PageEditorPostFormComponent content={content} setContent={setContent} onChageForm={onChageForm} isLoader={isLoader} fieldsValues={fieldsValues} setFieldsValues={setFieldsValues} idData={idData} {...props} />
                    </TabPane>
                    <TabPane tab="Settings" key="2">
                        <PageSettingPostFormComponent authors={authors} setAuthorsInput={setAuthorsInput} setTagsInput={setTagsInput} onChageForm={onChageForm} isLoader={isLoader} fieldsValues={fieldsValues} setFieldsValues={setFieldsValues} idData={idData} tags={tags} topics={topics} {...props} />
                    </TabPane>
                    <TabPane tab="Metadata" key="3">
                        <PageMetaDataPostFormComponent onChageForm={onChageForm} isLoader={isLoader} fieldsValues={fieldsValues} setFieldsValues={setFieldsValues} idData={idData} {...props} />
                    </TabPane>
                </Tabs>
                <ButtonAction
                    left={
                        <Link to="/article/posts">
                            <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                        </Link>
                    }
                    right={
                        <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                            Save
                            </Button>
                    }
                />
            </Form>
            <Confirm
                key="confirm-delete"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    let values: any = paramSubmit;
                    values = {
                        ...values,
                        metaData: JSON.stringify({
                            title: values.metaTitle,
                            description: values.metaDescription,
                            canonicalUrl: values.canonicalUrl
                        }),
                        twitterCard: JSON.stringify({
                            imageUrl: values.twitImageUrl,
                            title: values.twitTitle,
                            description: values.twitDescription,
                        }),
                        facebookCard: JSON.stringify({
                            imageUrl: values.fbImageUrl,
                            title: values.fbTitle,
                            description: values.fbDescription,
                        }),
                        status: values.publishDateTime && values.status && values.status == true ? "published" : detail && detail.status == 'published' ? "unpublished" : "draft",
                        authors: values.authors ? JSON.stringify(values.authors) : '[]',
                        tags: values.tags ? JSON.stringify(values.tags) : '[]'
                    };

                    delete values.metaTitle;
                    delete values.metaDescription;
                    delete values.canonicalUrl;
                    delete values.twitImageUrl;
                    delete values.twitTitle;
                    delete values.twitDescription;
                    delete values.fbImageUrl;
                    delete values.fbTitle;
                    delete values.fbDescription;

                    if (!values.publishDateTime) delete values.publishDateTime;

                    if (!idData) {
                        // do post data
                        postData(values);
                    } else {
                        // do update data
                        updateData(values, idData);
                    }
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/pages/post-form/libraries/index.tsx